import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography, Checkbox, FormControlLabel } from '@mui/material';
import ErrorDialog from '../ErrorDialog';
import { useNavigate, useParams } from 'react-router-dom';
import { rpc } from '../utils/RpcUtils';
import * as Constants from '../Constants';
import '../App.css';

const Event = () => {
  const [displayName, setDisplayName] = useState('');
  const [description, setDescription] = useState('');
  const [event, setEvent] = useState(null);
  const [playImmediately, setPlayImmediately] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const onFetchSuccess = (event) => {
      setEvent(event);
      event.attributes.forEach((attribute) => {
        if (attribute.name === Constants.ATTR_PLAY_IMMEDIATELY) {
          setPlayImmediately(attribute.value === 'true');
        };
      });
      setDisplayName(event.displayName);
      setDescription(event.description);
    };

    const fetchEvent = async (id) => {
      const params = {
        _id: id,
      };
      rpc({
        method: 'GetEvent',
        params,
        setErrorMessage,
        setOpenErrorDialog,
        onSuccess: onFetchSuccess
      });
    };
    if (id) {
      fetchEvent(id);
    }
  }, [id]);

  const onSuccess = () => {
    navigate('/events');
  };

  const updateEvent = async () => {
    if (displayName === '' || description === '') {
      setErrorMessage('DisplayName and Description fields are required');
      setOpenErrorDialog(true);
      return;
    }
    let attrs = event.attributes;
    let found = false;
    const strValue = playImmediately ? 'true' : 'false';
    attrs.forEach((attribute) => {
      if (attribute.name === Constants.ATTR_PLAY_IMMEDIATELY) {
        attribute.value = strValue;
        found = true;
      }
    });
    if (!found) {
      attrs = [{ name: Constants.ATTR_PLAY_IMMEDIATELY, value: strValue}];
    }
    const params = {
      _id: id,
      displayName,
      description,
      attributes: attrs
    };
    rpc({
      method: 'UpdateEvent',
      params,
      setErrorMessage,
      setOpenErrorDialog,
      onSuccess
    });
  };

  const deleteEvent = async () => {
    const params = {
      _id: id,
    };
    rpc({
      method: 'DeleteEvent',
      params,
      setErrorMessage,
      setOpenErrorDialog,
      onSuccess
    });
  };

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  const handleCheckboxChange = (event) => {
    setPlayImmediately(event.target.checked);
  };

  const getAttributes = () => {
    if (event === null || event.type !== Constants.EVENT_VIDEO) {
      return null;
    }
    return (
      <FormControlLabel
        control={<Checkbox checked={playImmediately} onChange={handleCheckboxChange} />}
        label="Play Immediately"
      />
    );
  };
  return (
    <div className="EventDetails">
      <Typography variant="h6" gutterBottom>
        Event {event !== null ? `${event.name}` : ''}
      </Typography>
      <TextField className="TextField"
        label="Display Name"
        value={displayName}
        onChange={(e) => setDisplayName(e.target.value)}
      />
      <TextField className="TextField"
        label="Description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />
      {getAttributes()}
      <div className="HorizontalContainer">
        <Button className="Button" variant="contained" color="primary" onClick={updateEvent}>
          Update
        </Button>
        <Button className="Button" variant="outlined" color="error" onClick={deleteEvent}>
          Delete
        </Button>
      </div>
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default Event;
